import React, {useState} from 'react';
import dayjs from "dayjs";
import {useTaxAuthorityContext} from "../../contexts/TaxAuthorityContext";
import DataTable from "../DataTable";
import FilterSelect from "../../../../common/components/FilterSelect";
import FieldCheckbox from "../../../../common/components/FieldCheckbox";
import FilterInput from "../../../../common/components/FilterInput";
import FilterDate from "../../../../common/components/FiltersDateFromTo";
import {columns} from "../../constants/columns";
import styles from './styles.module.scss';

const TaxAuthorityTable = () => {
  const [showMore, setShowMore] = useState(false);
  const [lastYear, setLastYear] = useState(false);
  const [last2Years, setLast2Years] = useState(false);
  const [last3Years, setLast3Years] = useState(false);

  const {
    list,
    totalResultCount,
    totalPageCount,
    page,
    setPage,
    cities, streets,
    search: {
      city,
      street,
      houseNumber,
      fromGush,
      toGush,
      fromHelka,
      toHelka,
      propertyType,
      fromSalePrice,
      toSalePrice,
      fromSaleDate,
      toSaleDate,
      fromRegisteredArea,
      toRegisteredArea,
      fromRoomsCount,
      toRoomsCount,
      fromEstimatePrice,
      toEstimatePrice,
      sellType,
      floor,
      floorsCount,
      fromBuildYear,
      toBuildYear,
      buildingAge,
      buildingUnitFunction,
      fromMunicipalArea,
      toMunicipalArea,
      soldShare,
      parking,
      elevator,
      gallery,
      yard,
      storage,
      roof,
      lot,
      removeDuplicates,
    }
  } = useTaxAuthorityContext();

  return (
    <div className={styles.listContainer}>
      <h1 className={styles.pageTitle}>נכסי השוואה</h1>
      <div className={styles.mainFiltersContainer}>
        <FilterSelect
          placeholder="עיר"
          filter={city}
          options={cities}
        />
        <FilterSelect
          placeholder="רחוב"
          filter={street}
          options={streets}
          disabled={!city?.value || city?.value === -1}
        />
        <FilterInput
          placeholder="בית"
          value={houseNumber.value}
          onChange={event => houseNumber.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="סוג הנכס"
          value={propertyType.value}
          onChange={event => propertyType.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="מגוש"
          value={fromGush.value}
          onChange={event => fromGush.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="עד גוש"
          value={toGush.value}
          onChange={event => toGush.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="מחלקה"
          value={fromHelka.value}
          onChange={event => fromHelka.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="עד חלקה"
          value={toHelka.value}
          onChange={event => toHelka.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="ממחיר המכירה"
          value={fromSalePrice.value}
          onChange={event => fromSalePrice.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="עד מחיר מכירה"
          value={toSalePrice.value}
          onChange={event => toSalePrice.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="משטח"
          value={fromRegisteredArea.value}
          onChange={event => fromRegisteredArea.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="עד שטח"
          value={toRegisteredArea.value}
          onChange={event => toRegisteredArea.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="ממספר חדרים"
          value={fromRoomsCount.value}
          onChange={event => fromRoomsCount.onChange(event.target.value)}
        />
        <FilterInput
          placeholder="עד מספר חדרים"
          value={toRoomsCount.value}
          onChange={event => toRoomsCount.onChange(event.target.value)}
        />
        <FilterDate
          placeholder={'מתאריך העסקה'}
          filter={fromSaleDate}
          maxDate={dayjs(fromSaleDate.value)}
          onChange={(value) => {
            fromSaleDate.onChange(value);
            setLastYear(false);
            setLast2Years(false);
            setLast3Years(false);
          }}
        />
        <FilterDate
          placeholder={'עד תאריך עסקה'}
          filter={toSaleDate}
          minDate={dayjs(toSaleDate.value)}
          onChange={(value) => {
            toSaleDate.onChange(value);
            setLastYear(false);
            setLast2Years(false);
            setLast3Years(false);
          }}
        />
        <FieldCheckbox
          fieldId={'lastYear'}
          variant={'slider'}
          checked={lastYear}
          label={'בשנה האחרונה'}
          onChange={(e) => {
            if (e.target.checked) {
              fromSaleDate.onChange(dayjs().startOf('year'));
              toSaleDate.onChange(dayjs());
              setLast2Years(false);
              setLast3Years(false);
            }
            setLastYear(e.target.checked);
          }}
          containerStyles={styles.marginTop}
        />
        <FieldCheckbox
          fieldId={'last2Years'}
          variant={'slider'}
          checked={last2Years}
          label={'שנתיים אחרונות'}
          onChange={(e) => {
            if (e.target.checked) {
              fromSaleDate.onChange(dayjs().subtract(2, 'year'))
              toSaleDate.onChange(dayjs())
              setLastYear(false);
              setLast3Years(false);
            }
            setLast2Years(e.target.checked);
          }}
          containerStyles={styles.marginTop}
        />
        <FieldCheckbox
          fieldId={'last3Years'}
          variant={'slider'}
          checked={last3Years}
          label={'שלוש השנים האחרונות'}
          onChange={(e) => {
            if (e.target.checked) {
              fromSaleDate.onChange(dayjs().subtract(3, 'year'));
              toSaleDate.onChange(dayjs());
              setLastYear(false);
              setLast2Years(false);
            }
            setLast3Years(e.target.checked);
          }}
          containerStyles={styles.marginTop}
        />
      </div>
      <FieldCheckbox
        fieldId={'showAdvanced'}
        variant={'slider'}
        label={'סינון מתקדם'}
        onChange={() => setShowMore(!showMore)}
        containerStyles={styles.sliderMargins}
      />
      {showMore &&
        <div className={styles.secondaryFiltersContainer}>
          <FilterInput
            placeholder="ממחיר מוצהר"
            value={fromEstimatePrice.value}
            onChange={event => fromEstimatePrice.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="עד מחיר מוצהר"
            value={toEstimatePrice.value}
            onChange={event => toEstimatePrice.onChange(event.target.value)}
          />
          <FilterDate
            placeholder={'משנת בניה'}
            filter={fromBuildYear}
            maxDate={dayjs(toBuildYear.value)}
            dateFormat={'YYYY'}
            picker={'year'}
          />
          <FilterDate
            placeholder={'עד שנת בניה'}
            filter={toBuildYear}
            dateFormat={'YYYY'}
            picker={'year'}
          />
          <FilterInput
            placeholder="משטח ארנונה"
            value={fromMunicipalArea.value}
            onChange={event => fromMunicipalArea.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="עד שטח ארנונה"
            value={toMunicipalArea.value}
            onChange={event => toMunicipalArea.onChange(event.target.value)}
          />

          <FilterInput
            placeholder="סוג העסקה"
            value={sellType.value}
            onChange={event => sellType.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="קומה"
            value={floor.value}
            onChange={event => floor.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="מספר קומות"
            value={floorsCount.value}
            onChange={event => floorsCount.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="גיל בניין"
            value={buildingAge.value}
            onChange={event => buildingAge.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="פונקציית יחידת בניין"
            value={buildingUnitFunction.value}
            onChange={event => buildingUnitFunction.onChange(event.target.value)}
          />
          <FieldCheckbox
            fieldId={'soldShare'}
            variant={'slider'}
            checked={soldShare?.value}
            label={'מניה שנמכרה (מלאה/חלקית)'}
            onChange={(e) => soldShare.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
            customLabelStyles={styles.checkboxSmallerFont}
          />
          <FieldCheckbox
            fieldId={'parking'}
            variant={'slider'}
            checked={parking?.value}
            label={'חניה'}
            onChange={(e) => parking.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
          <FieldCheckbox
            fieldId={'elevator'}
            variant={'slider'}
            checked={elevator?.value}
            label={'מעלית'}
            onChange={(e) => elevator.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
          <FieldCheckbox
            fieldId={'gallery'}
            variant={'slider'}
            checked={gallery?.value}
            label={'גלריה'}
            onChange={(e) => gallery.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
          <FieldCheckbox
            fieldId={'yard'}
            variant={'slider'}
            checked={yard?.value}
            label={'חצר'}
            onChange={(e) => yard.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
          <FieldCheckbox
            fieldId={'storage'}
            variant={'slider'}
            checked={storage?.value}
            label={'מחסן'}
            onChange={(e) => storage.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
          <FieldCheckbox
            fieldId={'roof'}
            variant={'slider'}
            checked={roof?.value}
            label={'גג'}
            onChange={(e) => roof.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
          <FieldCheckbox
            fieldId={'lot'}
            variant={'slider'}
            checked={lot?.value}
            label={'מגרש'}
            onChange={(e) => lot.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
          <FieldCheckbox
            fieldId={'removeDuplicates'}
            variant={'slider'}
            checked={removeDuplicates?.value}
            label={'הסר כפילויות'}
            onChange={(e) => removeDuplicates.onChange(e.target.checked)}
            containerStyles={styles.marginTop}
          />
        </div>
      }
      <DataTable
        data={list}
        columnsList={columns}
        totalPages={totalPageCount}
        totalResultCount={totalResultCount}
        page={page}
        setPage={setPage}
      />
    </div>
  );
};

export default TaxAuthorityTable;